import { useAuth } from '../../context/AuthContext'
import { DashboardWidgetGrid } from '../../components/dashboard/DashboardWidgetGrid'
import { getWidgetsForRole } from '../../components/dashboard/registry'

export default function OrgAdminDashboard() {
  const { user } = useAuth()
  const widgets = user ? getWidgetsForRole(user.role) : []

  return (
    <div className="max-w-[960px]">
      <div className="mb-7">
        <h1 className="m-0 mb-1 text-[1.4rem] font-bold text-text-heading">
          Organisation Overview
        </h1>
        <p className="m-0 text-[0.9rem] text-text-3">
          Signed in as {user?.full_name ?? user?.email}
        </p>
      </div>

      <DashboardWidgetGrid widgets={widgets} />
    </div>
  )
}
